/* eslint-disable */
import React from "react";
import { connect } from "dva";

// core components
import HeaderComponent from "./header/headercomp";
import Footer from "./footer/footer";

class LayoutRC extends React.Component {
  componentDidMount() {}

  render() {
    return [
      <div id="main-wrapper">
        <div className="page-wrapper">
          <div className="container-fluid">
            <HeaderComponent />
            {this.props.children}
            <Footer />
          </div>
        </div>
      </div>,
    ];
  }
}

export default LayoutRC;
